"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var utilities = _interopRequireWildcard(require("./utilities"));
var _message = _interopRequireDefault(require("./message"));
var _growl = _interopRequireDefault(require("@ux/growl"));
require("@ux/growl/styles");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Render Growl component and set messageData.
 *
 * @class OrderConfirmation
 * @public
 *
 * @returns {React.ReactElement} Growl Component
 */

class OrderConfirmation extends _react.Component {
  componentDidMount() {
    const orderId = utilities.getOrderIdFromCookie() || utilities.getOrderIdFromQuerystring(global) || this.props.orderId;
    if (orderId) {
      const messageData = utilities.getMessageDataFromCookie(orderId);
      if (messageData) {
        utilities.deleteOrderIdCookie(global);
        utilities.deleteMessageDataCookie(global, orderId);
        if (messageData.orderData) {
          utilities.captureEcomEvent(global, messageData.orderData);
        }
        if (messageData.message) {
          _growl.default.addGrowlMessage({
            title: messageData.message.title,
            children: /*#__PURE__*/_react.default.createElement(_message.default, messageData.message),
            emphasis: 'success',
            id: 'pd' + orderId,
            fade: false
          });
        }
      }
    }
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_growl.default, null);
  }
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */
exports.default = OrderConfirmation;
OrderConfirmation.propTypes = {
  /** Individual order identifier */
  orderId: _propTypes.default.string
};